<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw" epub:type="frontmatter dedication" id="Dedication1" role="doc-dedication">
<div class="block-rw dedication-rw" id="dedication1">
<p class="ded-rw" id="p27" style="text-align: center;"><span><span><em>To Luke Bryan, Jason Aldean, and Keith Urban</em></span></span></p>
<p class="ded-rw" id="p28" style="text-align: center;"><span><span><em>for writing the kind of music that</em></span></span></p>
<p class="ded-rw" id="p29" style="text-align: center;"><span><span><em>inspires my kind of</em></span></span></p>
<p class="ded-rw" id="p30" style="text-align: center;"><span><span><em>stories.</em></span></span></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s003-Dedication-01.vue?3a06d8c3